<template lang="html">

  <div data="resumen" class="cv-part" v-if>
    <h2 class="title" :edit="showedit" @click="openedit" :empty="!!!resumenedit">Resumen</h2>
    <p v-html="resumenedit"></p>

    <div class="cover-popup row-center" v-if="showedit">
      <div class="popup">
        <a class="close" @click="showedit = false">✕</a>
        <h2 class="title-pop">Editar resumen</h2>
        <div class="textarea">
          <label for="editarresumen">Escribe aquí un resumen sobre tí</label>
          <textarea name="resumen" v-model="resumenedit" id="editarresumen" v-validate="'max:800'"></textarea>
          <span class="error animated shake" v-if="errors.has('resumen')">{{ errors.first('resumen') }}</span>
        </div>
        <button class="btn" @click="saveResumen" :loading="loading">Guardar</button>
      </div>
    </div>

  </div>

</template>

<script lang="js">

  import {mapGetters, mapActions} from 'vuex';

  export default {
    name: 'resumen-cv',
    props : ['data'],
    mounted(){
      this.resumenedit = this.data;
    },
    data() {
      return {
        showedit: false,
        resumenedit : '',
        loading : false
      }
    },
    methods :{
      ...mapActions(['canEditCv','editResumen']),
      openedit(){
        this.canEditCv().then(r =>{
          (r) ? this.showedit = true : '';
        });
      },
      saveResumen(){
        this.loading = true;
        this.editResumen(this.resumenedit).then(r => {
            this.loading = false;
            this.showedit = false;
        });
      }
    }, 
  }
</script>

<style scoped lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/views/mi-cv/resumen.vue